import cargowareXIcon from '@assets/cargowareX.png'

/**
 * 根据 ENTRY_TYPE 设置文档标题和 favicon
 */
export function useDocumentMeta() {
  /**
   * 设置文档标题
   */
  const setDocumentTitle = (title: string) => {
    document.title = title
    console.log('[TP_META] 文档标题已设置:', title)
  }

  /**
   * 设置 favicon
   */
  const setFavicon = (iconUrl: string) => {
    // 移除已存在的 favicon link 标签
    const existingLinks = document.querySelectorAll("link[rel*='icon']")
    existingLinks.forEach(link => link.remove())

    // 创建新的 favicon link 标签
    const link = document.createElement('link')
    link.rel = 'icon'
    link.type = 'image/png'
    link.href = iconUrl
    document.head.appendChild(link)

    console.log('[TP_META] Favicon 已设置:', iconUrl)
  }

  /**
   * 根据 ENTRY_TYPE 初始化文档元信息
   */
  const initDocumentMeta = () => {
    const entryType = ENTRY_TYPE || 'portal'

    // 根据入口类型设置标题
    if (entryType === 'home') {
      setDocumentTitle('CargoWare X')
    } else {
      setDocumentTitle('CargoWare X Portal')
    }

    // 设置统一的 favicon
    setFavicon(cargowareXIcon)
  }

  return {
    setDocumentTitle,
    setFavicon,
    initDocumentMeta
  }
}
